"use client";

import { Column } from "@faire/web/slate/Layout/Column";

export const SDUICarouselRendererWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <Column data-test-id="carousel-renderer">{children}</Column>;
};
